"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuturesDataUtils = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const constants_1 = require("../../../config/constants");
const balances_1 = require("../../../data/balances");
const binance_1 = require("../../../types/binance");
/*
// For USDM:
// необходимо в наш пункт marginBalance на фронте забирать значение из ключа availableBalance из ответа Binance. Мы так делаем в Windows терминале. При наличии открытых ордеров/позиций он изменяется и отображает маржу, которая доступна для открытия новых ордеров/позиций.
*/
class FuturesDataUtils {
    static createBalancesFromAccountInformation(accountInfo, balanceParams) {
        const userAssets = FuturesDataUtils.getNonNullAssetsFromAccountInformation(accountInfo);
        return new balances_1.FuturesUserBalance(Object.assign(Object.assign({}, balanceParams), { initialAssets: FuturesDataUtils.assetRawToBalanceInitialAsset(userAssets), marketData: {
                marketAssets: new Map()
            } }));
    }
    static getNonNullAssetsFromAccountInformation(accountInfo) {
        return accountInfo.assets.filter(asset => {
            return Number(asset.walletBalance) !== 0;
        });
    }
    static assetRawToBalanceInitialAsset(assets) {
        return assets.map(asset => {
            return {
                assetId: asset.asset,
                assetBalance: Number(asset.walletBalance)
            };
        });
    }
    static calcUnPnl(params) {
        const { positionAmount, entryPrice, markPrice, positionSide } = params;
        const unPnl = new bignumber_js_1.default(positionAmount).abs().multipliedBy(entryPrice)
            .minus(new bignumber_js_1.default(positionAmount).abs().multipliedBy(markPrice));
        const priceDropppedMutipliersBySide = {
            [binance_1.EPositionSide.SHORT]: 1,
            [binance_1.EPositionSide.LONG]: -1
        };
        const multiplier = priceDropppedMutipliersBySide[positionSide];
        return unPnl.multipliedBy(multiplier);
    }
    // unrealizedProfit / (entryPrice * positionAmt)
    static calcUnPnlPercent(params) {
        const { unrealisedPnl, positionAmount, entryPrice } = params;
        const priceAmountProduct = new bignumber_js_1.default(entryPrice).multipliedBy(positionAmount);
        const unPnlPercent = priceAmountProduct.isZero()
            ? constants_1.BN_ZERO
            : new bignumber_js_1.default(unrealisedPnl).dividedBy(priceAmountProduct).multipliedBy(constants_1.PERCENT_MULTIPLIER).dp(2);
        return unPnlPercent;
    }
}
exports.FuturesDataUtils = FuturesDataUtils;
